'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

var _components2 = require('components');

var _pacomo = require('utils/pacomo');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldSet = function FieldSet(_ref) {
    var requirement = _ref.requirement,
        fields = _ref.fields,
        _ref$noRequirement = _ref.noRequirement,
        noRequirement = _ref$noRequirement === undefined ? false : _ref$noRequirement;

    if (requirement || noRequirement) {
        return _react2.default.createElement(
            'fieldset',
            { className: (0, _classnames2.default)({ 'multi-fieldset': fields.length > 1 }) },
            _react2.default.createElement(
                'div',
                { className: 'fields-row' },
                !noRequirement && _react2.default.createElement(_components2.CompletedByTag, { requirement: requirement }),
                fields.map(function (field, i) {
                    if (!field.hideField) {
                        var labelBlock = void 0;
                        var fieldBlock = void 0;
                        if (!field.field || field.field.props.type === 'checkbox') {
                            //Just keep the checkbox and the input wrapped up together
                            // Might create some accessibility warnings though
                            labelBlock = _react2.default.createElement(
                                'label',
                                null,
                                field.field && field.field
                            );
                            fieldBlock = _react2.default.createElement(
                                'div',
                                { className: 'check' },
                                _react2.default.createElement(
                                    'label',
                                    { className: 'label', htmlFor: field.id && field.id },
                                    field.label
                                )
                            );
                        } else {
                            labelBlock = _react2.default.createElement(
                                'label',
                                { className: 'label', htmlFor: field.id },
                                field.label,
                                field.isOptional && _react2.default.createElement(
                                    'span',
                                    { className: 'optional' },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formMessages.fieldOptional', defaultMessage: 'Optional' })
                                )
                            );
                            fieldBlock = field.field;
                        }
                        return _react2.default.createElement(
                            'div',
                            { className: 'row', key: i },
                            labelBlock,
                            _react2.default.createElement(
                                'div',
                                { className: 'fields' },
                                fieldBlock
                            )
                        );
                    } else {
                        return null;
                    }
                })
            )
        );
    } else {
        return _react2.default.createElement('span', null); // Can't return null because of pacomoTransformer
    }
};
exports.default = (0, _pacomo.pacomoTransformer)(FieldSet);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/forms/FieldSet.js
// module id = 305
// module chunks = 0